<script setup lang="ts">
import { carouselItems } from "@/util/constants";
import {
  UICarousel,
  UICollapse,
  UICollapseItem,
  UITextSmMedium,
  UITextSmRegular,
} from "@gohighlevel/ghl-ui";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>

<template>
  <div class="mt-3 flex items-start self-stretch rounded-lg border border-gray-200 p-3">
    <UICollapse :accordion="true" :arrow-placement="'right'" :display-directive="'show'">
      <UICollapseItem id="howItWorks" name="howItWorks">
        <template #header>
          <div class="flex w-full items-center justify-between">
            <UITextSmMedium class="text-ghl-gray-700 normal-case">{{
              t("quiz.category.howItWorks")
            }}</UITextSmMedium>
          </div></template
        >
        <div>
          <ol class="space-y-3 p-0">
            <li class="flex items-center gap-3">
              <span
                class="flex h-5 w-5 items-center justify-center rounded-full bg-primary-100 font-semibold text-primary-700"
                >1</span
              >
              <UITextSmRegular>{{ t("quiz.category.addCategoryMessage") }}</UITextSmRegular>
            </li>
            <li class="flex items-center gap-3">
              <span
                class="flex h-5 w-5 items-center justify-center rounded-full bg-primary-100 font-semibold text-primary-700"
                >2</span
              >
              <UITextSmRegular>{{ t("quiz.category.assignCategoryMessage") }}</UITextSmRegular>
            </li>
            <li class="flex items-center gap-3">
              <span
                class="flex h-5 w-5 items-center justify-center rounded-full bg-primary-100 font-semibold text-primary-700"
                >3</span
              >
              <UITextSmRegular>{{ t("quiz.category.editResultsMessage") }}</UITextSmRegular>
            </li>
          </ol>
          <UICarousel
            :auto-play="true"
            direction="horizontal"
            dot-placement="bottom"
            dot-type="dot"
            class-names="howItWorksCarousel"
            :items-per-view="1"
            :loop="true"
            :show-dots="true"
            :interval="2000"
            effect="slide"
            :touchable="true"
            :carousel-items="carouselItems"
          />
        </div>
      </UICollapseItem>
    </UICollapse>
  </div>
</template>

<style scoped>
.howItWorksCarousel {
  border-radius: 8px;
}

.howItWorksCarousel :deep(.n-carousel__dots) {
  bottom: 4px;
}
</style>
